import { atomWithStorage } from "jotai/utils";
import { LOCAL_STORAGE_PREFIX } from "../constants/store";

export const isHelpTextOpenAtom = atomWithStorage(LOCAL_STORAGE_PREFIX, true);
